import React, { Fragment, Component } from 'react';
import { Card, CardBody, CardFooter, Col, Table } from 'reactstrap';
import { P, Image, Btn } from '../../AbstractElements';
// import { Country, Currency, Date, Name } from '../../Constant';
// import { DealerTables } from '../../Data/Dash';
import { Link } from 'react-router-dom';
import axios from "axios";
import { API_URL } from "../../Constant";
import NewStudentModal from "./NewStudentModal";
import ConfirmRemovalModal from "./ConfirmRemovalModal";

class StudentList extends Component {
  render() {

    const students = this.props.students;
    return (
      <Fragment>
        <Col xl="12" className="des-xl-100 xl-100 box-col-12 deals-sec">
          <Card>
            <CardBody>
              <div className="best-dealer-table responsive-tbl">
                <div className="item">
                  <div className="table-responsive product-list">
                    <Table borderless>
                      <thead>
                        <tr>
                          {/* <th>No</th> */}
                          <th>Name</th>
                          <th>Email</th>
                          <th>Document</th>
                          <th>Phone</th>
                          <th>Registration</th>
                          <th>Operations</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!students || students.length <= 0 ? (
                          <tr>
                            <td colSpan="6" align="center">
                              <b>Ops, no one here yet</b>
                            </td>
                          </tr>
                        ) : (
                          students.map((student) => {
                            return (
                              <tr key={student.pk}>

                                {/* <td>{item.srno}</td> */}
                                <td>
                                  <div className="t-title d-inline-block align-middle">
                                    <Link to={`${process.env.PUBLIC_URL}/users/userprofile`}>
                                      {/* <Image attrImage={{
                                        className: 'img-40 m-r-15 rounded-circle align-top', alt: '', dataoriginaltitle: '', title: ''
                                      }}
                                      /> */}
                                      </Link>
                                    {/* <div className="status-circle bg-primary"></div> */}
                                    <div className="d-inline-block"><span><Link to={`${process.env.PUBLIC_URL}/users/userprofile`}>{student.name}</Link></span>
                                      {/* <P>{item.year}</P> */}
                                    </div>
                                  </div>
                                </td>
                                <td>{student.email}</td>
                                <td>{student.document}</td>
                                <td>{student.phone}</td>
                                <td>{student.registrationDate}</td>
                                <td><NewStudentModal
                                    create={false}
                                    student={student}
                                    resetState={this.props.resetState}
                                  />
                                  &nbsp;&nbsp;
                                  <ConfirmRemovalModal
                                    pk={student.pk}
                                    resetState={this.props.resetState}
                                  />
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        {/* <CardFooter className="pt-0">
        <Btn attrBtn={{ color: 'primary', className: 'me-2' }}>{Submit}</Btn>
        <Btn attrBtn={{ color: 'secondary' }}>{Cancel}</Btn>
      </CardFooter> */}
      </Fragment>
    );
  };
}
export default StudentList;